import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/Icons/hidden.svg'
import _imports_1 from '@/assets/img/Icons/un-hidden.svg'
import _imports_2 from '@/assets/img/Icons/iconRight.svg'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "field form-group" }
const _hoisted_7 = { class: "field form-group" }
const _hoisted_8 = { class: "password" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1
}
const _hoisted_11 = { class: "field form-group d-flex align-items-center justify-content-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)

import {
  ref,
  computed,
  onMounted,
  watch,
  getCurrentInstance,
} from "vue";

import { AdapterApiService } from "@pages/_adapter";
import { notify } from "@/app/notifications";
import ErrorModel from "./adapter/models/errorModel";
import { AdapterAuthService } from "./adapter";
import LoginResponse from "@/api/main/dataSource/api/aba/public/services/models/login/LoginResponse";
import UserType from "@/api/main/models/Enums/UserType";
import { useRoute, useRouter } from "vue-router";
import * as Routes from "@/router/routerNames";
import EnumTypeIdentified from "@/api/main/dataSource/api/aba/data/models/models/EnumTypeIdentified";
// Определение пропсов компонента
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'login-page',
  props: {
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
},
  setup(__props) {

// Импорты из Vue 3 Composition API
const router = useRouter();
const props = __props;

const authErrorMessage = ref("Wrong login or password");
const adapter = AdapterAuthService.getInstance();
const Login = ref(""); //sss@gmail.com
const Password = ref(""); //RBSNWUBOOH
const isPassword = ref(true);
const errorModel = ref(new ErrorModel());
const route = useRoute();

const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  localStorage.setItem("locale", route.query?.lng.toString() || "cz");
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;

  const res = await adapter.getCurrentUser();

  if (!res.IsSuccess) {
    return;
  }
  router.push({ path: "/" });
});

async function onLogin() {
  const res = await adapter.loginUser({
    Email: Login.value,
    Password: Password.value,
  });

  // Проверяем тип возвращаемого значения
  if (res.IsSuccess) {
    router.push({ path: "/" });
  }

  errorModel.value.ErrorMessage = res.ErrorMessage;
  authErrorMessage.value = res.ErrorMessage;
  // isAuthNoError.value = res != null;
}
function validEmail(value: string): boolean {
  // Регулярное выражение для проверки валидности email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Проверяем, что строка не пуста и соответствует паттерну
  return emailPattern.test(value);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_error_message = _resolveComponent("ui-error-message")!
  const _component_layout_without_sidebar = _resolveComponent("layout-without-sidebar")!

  return (_openBlock(), _createBlock(_component_layout_without_sidebar, { isShowSideBar: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, " " + _toDisplayString(_ctx.$t("login.WELCOME BACK")), 1),
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("login.New to Swipe")) + " ", 1),
              _createVNode(_component_router_link, { to: "/signup" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("login.Sign up")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ui_input, {
              modelValue: Login.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Login).value = $event)),
              type: "email",
              headerText: _ctx.$t('Your email address'),
              warningMsg: _ctx.$t('Your email address'),
              required: ""
            }, null, 8, ["modelValue", "headerText", "warningMsg"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ui_input, {
                type: isPassword.value ? 'Password' : 'Text',
                modelValue: Password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((Password).value = $event)),
                headerText: _ctx.$t('login.Your password'),
                warningMsg: _ctx.$localization.getTranslate('FillThisField'),
                required: ""
              }, null, 8, ["type", "modelValue", "headerText", "warningMsg"]),
              _createVNode(_component_ui_button, {
                class: "show-pass",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isPassword.value = !isPassword.value))
              }, {
                default: _withCtx(() => [
                  (isPassword.value)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_ui_error_message, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorModel.value.ErrorMessage), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "ui_continue_button",
              onClick: onLogin
            }, [
              _hoisted_12,
              _createTextVNode("   "),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("login.Log In")), 1)
            ]),
            _createVNode(_component_router_link, { to: "forgot-password" }, {
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.$t("login.Forgot your password")) + "?", 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})